// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//

import localizer from 'share/localization/Izenda.Localizer';
import Validator from 'share/components/hoc/Izenda.Validator';

const ACCESS_MODE = {
  REPORT: 0,
  DASHBOARD: 1,
  TENANT: 2
};

const USER_ACCESS_MODE = {
  ACCESS: 1,
  SCHEDULE: 2
};

export default {
  get DEFAULT_VALUE() {
    return {
      SEARCH_CRITERIA: 'All',
      SORT_DIRS: {
        shareWith: 'DESC'
      }
    };
  },
  get ACCESS_TABLE_DEF() {
    return {
      selected: {
        key: 'selected',
        width: 30,
        title: '',
        sortable: false,
        columnKey: 'selected ',
        fixed: true,
        align: 'center'
      },
      shareWith: {
        key: 'shareWith',
        width: 300,
        title: localizer.getText('ACCESS_CONSTANT_ACCESS_TABLE_DEF_SHARE_WITH'),
        sortable: true,
        columnKey: 'shareWith'
      },
      accessRight: {
        key: 'accessRight',
        width: 150,
        title: localizer.getText('ACCESS_CONSTANT_ACCESS_TABLE_DEF_ACCESS_RIGHT'),
        sortable: true,
        columnKey: 'accessRight',
        fixed: true
      },
      actions: {
        key: 'actions',
        width: 80,
        title: localizer.getText('COMMON_LABEL_ACTION'),
        sortable: false,
        columnKey: 'actions',
        fixed: true,
        align: 'center'
      }
    };
  },
  get SEARCH_OPTIONS() {
    return [
      { value: 'All', label: localizer.getText('COMMON_LABEL_ALL') },
      { value: 'shareWith', label: localizer.getText('ACCESS_CONSTANT_LABEL_SEARCH_OPTION_SHARE_WITH') },
      { value: 'accessRight', label: localizer.getText('ACCESS_CONSTANT_LABEL_SEARCH_OPTION_ACCESS_RIGHT') }
    ];
  },
  get ASSIGNED_TYPE() {
    return [
      { value: 1, label: localizer.getText('ACCESS_CONSTANT_LABEL_ASSIGNED_TYPE_EVERYONE') },
      { value: 2, label: localizer.getText('COMMON_LABEL_ROLE') },
      { value: 3, label: localizer.getText('ACCESS_CONSTANT_LABEL_ASSIGNED_TYPE_USER') }
    ];
  },
  COMPONENT_CONFIG: {
    1: null,
    2: {
      component: require('modules/User/Izenda.RoleLookUp'),
      props: {
        usingPopup: true,
        valueField: 'id',
        textField: 'name'
      }
    },
    3: {
      component: require('modules/User/Izenda.UserLookUp'),
      props: {
        useSearchName: true,
        usingPopup: true,
        valueField: 'id',
        textField: 'name',
        userModeType: 1,
        useEmailInOptions: true
      }
    }
  },
  get CONSTRAINTS() {
    return {
      SHARE_WITH: {
        presence: {
          presence: true,
          message: localizer.getText('COMMON_CONSTRAINT_REQUIRED')
        }
      },
      ACCESS_RIGHT: {
        presence: {
          presence: true,
          message: localizer.getText('ACCESS_CONSTANT_CONSTRAINT_ACCESS_RIGHT')
        }
      },
      USER: {
        presence: {
          presence: true,
          message: localizer.getText('ACCESS_CONSTANT_CONSTRAINT_USER')
        }
      },
      ROLE: {
        presence: {
          presence: true,
          message: localizer.getText('ACCESS_CONSTANT_CONSTRAINT_ROLE')
        }
      },
      REPORT_OWNER: {
        presence: {
          presence: true,
          message: localizer.getText('ACCESS_CONSTANT_CONSTRAINT_REPORT_OWNER')
        }
      },
      DASHBOARD_OWNER: {
        presence: {
          presence: true,
          message: localizer.getText('ACCESS_CONSTANT_CONSTRAINT_DASHBOARD_OWNER')
        }
      }
    };
  },
  get MESSAGE() {
    return {
      M01a: localizer.getText('ACCESS_CONSTANT_MESSAGE_CONFIRM_DELETE_SHARED_INSTANCE'),
      M01b: localizer.getText('ACCESS_CONSTANT_MESSAGE_CONFIRM_DELETE_SELECTED_SHARED_INSTANCES'),
      M02a: localizer.getText('ACCESS_CONSTANT_MESSAGE_CONFIRM_DELETE_DEFAULT_ACCESS_RIGHT'),
      M02b: localizer.getText('ACCESS_CONSTANT_MESSAGE_CONFIRM_DELETE_SELECTED_DEFAULT_ACCESS_RIGHT'),
      REMOVE_ROLE: localizer.getText('ACCESS_CONSTANT_MESSAGE_REMOVE_ROLES'),
      REMOVE_USER: localizer.getText('ACCESS_CONSTANT_MESSAGE_REMOVE_USERS'),
      REMOVE_DASHBOARD_USER: localizer.getText('DASHBOARD_CONSTANT_MESSAGE_REMOVE_USERS'),
      REMOVE_DASHBOARD_ROLE: localizer.getText('DASHBOARD_CONSTANT_MESSAGE_REMOVE_ROLES')
    };
  },
  get PERMISSION_ACCESS_TABLE_DEF() {
    return {
      selected: {
        key: 'selected',
        width: 30,
        title: '',
        sortable: false,
        columnKey: 'selected ',
        fixed: true,
        align: 'center'
      },
      shareWith: {
        key: 'shareWith',
        width: 200,
        get title() {
          return localizer.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_SHARE_WITH');
        },
        sortable: true,
        columnKey: 'shareWith'
      },
      reportAccessRightId: {
        key: 'reportAccessRight',
        width: 200,
        get title() {
          return localizer.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_REPORT_ACCESS_RIGHT');
        },
        sortable: true,
        columnKey: 'reportAccessRights',
        fixed: true
      },
      dashboardAccessRightId: {
        key: 'dashboardAccessRight',
        width: 200,
        get title() {
          return localizer.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_DASHBOARD_ACCESS_RIGHT');
        },
        sortable: true,
        columnKey: 'dashboardAccessRights',
        fixed: true
      },
      actions: {
        key: 'actions',
        width: 80,
        get title() {
          return localizer.getText('COMMON_LABEL_ACTION');
        },
        sortable: false,
        columnKey: 'actions',
        fixed: true,
        align: 'center'
      }
    };
  },
  get PERMISSION_SEARCH_OPTIONS() {
    return [
      { value: 'All', label: localizer.getText('COMMON_LABEL_ALL') },
      { value: 'shareWith', label: localizer.getText('ACCESS_CONSTANT_LABEL_PERMISSION_SEARCH_OPTION_SHARE_WITH') },
      {
        value: 'reportAccessRights',
        label: localizer.getText('ACCESS_CONSTANT_LABEL_PERMISSION_SEARCH_OPTION_REPORT_ACCESS_RIGHT')
      },
      {
        value: 'dashboardAccessRights',
        label: localizer.getText('ACCESS_CONSTANT_LABEL_PERMISSION_SEARCH_OPTION_DASHBOARD_ACCESS_RIGHT')
      }
    ];
  },
  get ACCESS_MODE() {
    return ACCESS_MODE;
  },
  get BUTTON() {
    return {
      ADD_SHARING_LABEL: localizer.getText('ACCESS_CONSTANT_LABEL_ADD_SHARING'),
      ADD_DEFAULT_ACCESS: localizer.getText('ACCESS_CONSTANT_LABEL_ADD_DEFAULT_ACCESS')
    };
  },
  get USER_ACCESS_MODE() {
    return USER_ACCESS_MODE;
  },
  get ACCESS_DEFAULT_GRID() {
    return {
      assignedTypeName: {
        key: 'assignedTypeName',
        width: 150,
        get title() {
          return localizer.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_SHARE_WITH');
        },
        sortable: true,
        columnKey: 'assignedTypeName ',
        fixed: true
      },
      accessorNames: {
        key: 'accessorNames',
        width: 340,
        get title() {
          return localizer.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_SHARING_SELECTION');
        },
        sortable: true,
        columnKey: 'accessorNames',
        fixed: true
      },
      reportAccessRights: {
        key: 'reportAccessRights',
        width: 180,
        get title() {
          return localizer.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_REPORT_ACCESS_RIGHT');
        },
        sortable: true,
        columnKey: 'reportAccessRights',
        fixed: true
      },
      dashboardAccessRights: {
        key: 'dashboardAccessRights',
        width: 200,
        get title() {
          return localizer.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_DASHBOARD_ACCESS_RIGHT');
        },
        sortable: true,
        columnKey: 'dashboardAccessRights'
      }
    };
  },
  ASSIGN_TYPE: {
    ALL: 1,
    ROLE: 2,
    USER: 3
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.AccessConstants.js